import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import useCurrentUser from "../../hooks/useCurrentUser";
import AdminPasswords from "./AdminPasswords";
import AdminListsRankings from "./lists/AdminListsRankings";
import AdminRemoteAllNflPlayers from "./remote/entities/nflPlayers/AdminRemoteAllNflPlayers";
import AdminRemoteAllPlayers from "./remote/entities/players/AdminRemoteAllPlayers";
import AdminRemoteConfigAdd from "./remote/sourcesAndPulls/AdminRemoteConfigAdd";
import AdminRemoteConfigEdit from "./remote/sourcesAndPulls/AdminRemoteConfigEdit";
import AdminRemotePull from "./remote/sourcesAndPulls/AdminRemotePull";
import AdminRemoteNflPlayerSearch from "./remote/entities/nflPlayers/AdminRemoteNflPlayerSearch";
import AdminRemoteReviews from "./remote/reviews/AdminRemoteReviews";
import AdminRemoteSource from "./remote/sourcesAndPulls/AdminRemoteSource";
import AdminRemoteTemplate from "./remote/sourcesAndPulls/AdminRemoteTemplate";
import AdminRemoteReviewsNflPlayer from "./remote/entities/nflPlayers/AdminRemoteReviewsNflPlayer";
import AdminRemoteReviewsNflPlayers from "./remote/entities/nflPlayers/AdminRemoteReviewsNflPlayers";
import RouteWrapper from "../layout/RouteWrapper";
import Admin from "./Admin";
import AdminRemote from "./remote/AdminRemote";
import AdminRemoteDomain from "./remote/sourcesAndPulls/AdminRemoteDomain";

const AdminRoutes = () => {
  const currentUser = useCurrentUser();
  const { href, pathname } = window.location;

  if (!currentUser.isAdmin()) {
    return <h1>Not authorized</h1>;
  }

  const routes = [
    {
      path: "/lists/rankings",
      comp: AdminListsRankings,
    },
    { path: "/passwords/:league/:season", comp: AdminPasswords },
    {
      path: "/remote/config/add",
      comp: AdminRemoteConfigAdd,
    },
    {
      path: "/remote/all/NflPlayer",
      comp: AdminRemoteAllNflPlayers,
    },
    {
      path: "/remote/all/players",
      comp: AdminRemoteAllPlayers,
    },
    {
      path: "/remote/search/NflPlayer",
      comp: AdminRemoteNflPlayerSearch,
    },
    {
      path: "/remote/reviews/NflPlayer/:review",
      comp: AdminRemoteReviewsNflPlayer,
    },
    {
      path: "/remote/reviews/NflPlayer",
      comp: AdminRemoteReviewsNflPlayers,
    },
    {
      path: "/remote/reviews",
      comp: AdminRemoteReviews,
    },
    {
      path: "/remote/:domain/:template/config",
      comp: AdminRemoteConfigEdit,
    },
    {
      path: "/remote/:domain/:template/:source/:pull",
      comp: AdminRemotePull,
    },
    {
      path: "/remote/:domain/:template/:source",
      comp: AdminRemoteSource,
    },
    {
      path: "/remote/:domain/:template",
      comp: AdminRemoteTemplate,
    },
    {
      path: "/remote/:domain",
      comp: AdminRemoteDomain,
    },
    {
      path: "/remote",
      comp: AdminRemote,
    },
    { path: "/", comp: Admin, exact: true },
  ];

  return (
    <Switch>
      {routes.map(({ path, comp, exact }, i) => {
        path = "/admin" + path;
        const Comp = comp;
        return exact ? (
          <Route
            key={i}
            path={path}
            exact
            render={() => (
              <RouteWrapper>
                <Comp />
              </RouteWrapper>
            )}
          />
        ) : (
          <Route
            key={i}
            path={path}
            render={() => (
              <RouteWrapper>
                <Comp />
              </RouteWrapper>
            )}
          />
        );
      })}
      <Redirect
        to={{
          pathname: "/not-found",
          state: {
            href,
            pathname,
          },
        }}
      />
    </Switch>
  );
};

export default AdminRoutes;
